import { useState } from "react";
import { DoorOpen } from "lucide-react";
import { formatPrice, formatBookingDate } from "../../utils/sessionTurnUtils";
import BookingCardShell from "./BookingCardShell";

const RoomSearchCard = ({ rooms, searchDates }: any) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <BookingCardShell
            icon={<DoorOpen />}
            tone="primary"
            title="Rooms Available"
            badge={rooms.length}
            meta={searchDates && <>{formatBookingDate(searchDates.checkIn)} &ndash; {formatBookingDate(searchDates.checkOut)}</>}
            expanded={expanded}
            onToggle={() => setExpanded(!expanded)}
        >
            <ul className="flex flex-col divide-y divide-border">
                {rooms.map((room, idx) => (
                    <li key={room.room_id || idx} className="flex items-center justify-between gap-3 py-1.5">
                        <span>{room.room_name}</span>
                        <span className="font-medium text-primary">{formatPrice(room.starting_from, room.currency)}</span>
                    </li>
                ))}
            </ul>
        </BookingCardShell>
    );
};

export default RoomSearchCard;
